import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import {
  Content,
  TopWrapper,
  BottomWrapper,
  EventDate,
  EventDetails,
  EventImageContainer,
  EventImage,
  EventInfo,
  EventTitle,
  EventVenue,
  GetTicketsButton,
  Separator,
  TicketLocation,
  SeatColumn,
  SeatMapContainer,
  SeatMap,
  TotalRow,
  TaxLegend,
  BreakdownRow,
  Loader,
  TaxBottomLegend,
  EventDetailsContainer,
  TitleInfo,
  AvailabilityMessage,
} from "./styles";
import { Link } from "@ticketmaster/aurora";
import MessageModal from "webapp-common-ui/src/components/message-modal";
import ContentTransition from "webapp-common-ui/src/components/content-transition";
import SocialShareError from "./social-share-error";
import SocialShareInfoMessages from "./social-share-info-messages";

import {
  openGlobalLoader,
  openGlobalModal,
} from "webapp-common-ui/src/actions/global-modal-actions";
import {trackEvent} from "../../actions/analytics";
import withCss from "webapp-common-ui/src/utils/with-css";
import OpenGraph from "./open-graph";
import moment from 'moment-timezone';

@withCss
@connect(
  (store) => {
    return {
      messages: store.messages,
    };
  },
  {
    openGlobalModal,
    openGlobalLoader,
    trackEvent,
  }
)
class SocialShare extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listingInfo: {},
      isLoading: true,
      isError: false,
      hasAcceptedTerms: false,
      errorDetails: "default",
    };
  }

  componentDidMount() {
    const script = document.createElement("script");
    script.src = siteContext.checkoutSdk; // Replace with the environment
    script.async = true;
    document.head.appendChild(script);
    this.fetchEvent();
    setTimeout(() => {
      this.trackEvent("Page Visited");
    }, 1);
  }

  fetchEvent = () => {
    const url = window.pageContext.socialShareLink.source;

    //  "https://my-ltmus.aws.ticketmaster.net:8081/webapp/v1/ds/ZkQ85ueCeo/getListing"; 
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          this.trackEvent("General Error");
          this.setState({ isError: true, isLoading: false });
        }
        return response.json();
      })
      .then((data) => {
      
        if (data.error || data.message) {
          if (data.message) {
            this.trackEvent("General Error");
            this.setState({
              listingInfo: data,
              isError: true,
              isLoading: false,
            });
          } else if (
            data.error.code == "PostingCanceledException" ||
            data.error.code == "PostingSoldException"
          ) {
            this.trackEvent("Listing Unavaliable or Cancelled");
            this.setState({
              listingInfo: data,
              isError: true,
              isLoading: false,
              errorDetails: "notAvailable",
            });
          } else if (data.error.code == "PendingPostedException") {
            //Use the correct code for pending
            this.trackEvent("Listing Pending");
            this.setState({
              listingInfo: data,
              isError: true,
              isLoading: false,
              errorDetails: "pending",
            });
          } else if (data.error.code == "PostingExpiredException") {
            this.trackEvent("Event Expired");
            this.setState({
              listingInfo: data,
              isError: true,
              isLoading: false,
              errorDetails: "expired",
            });
          } else {
            this.trackEvent("General Error");
            this.setState({
              listingInfo: data,
              isError: true,
              isLoading: false,
            });
          }
        } else {
          this.setState({ listingInfo: data, isLoading: false });
        }
      });
  };

  trackEvent = (action) => {
    this.props.trackEvent({
      category: "Fan Seller",
      label: "Share Listing",
      action,
      value: 1,
    });
  };

  openModal = () => {
    this.props.openGlobalLoader();
  };

  buttonHandler = (reserveInput) => {
    this.openModal();
    this.trackEvent("Get Tickets Button Clicked");
    window.CheckoutSDK.init({
      eventId: reserveInput.eventId,
    }).then((checkoutSDK) => {
      checkoutSDK
        .checkout(reserveInput, {
          appview: true,
          appviewVersion: 4,
          channel: 0,
          layout: "1-[1,2,3,4]",
          redirect: true,
          source: 2,
        })
        .then(console.log)
        .catch(this.trackEvent("Get Tickets Button Error"));
    });
  };

  handleTermsAccepted = (hasAcceptedTermsValue) => {
    this.setState({ hasAcceptedTerms: hasAcceptedTermsValue });
  };

  checkBoxRequired(eventInfo) {
    return (
      eventInfo &&
      ((eventInfo.edpPopup && eventInfo.edpPopup.forceButtonEnabled) ||
        eventInfo.allInclusivePricing)
    );
  }

  render() {
    const listingInfo = this.state.listingInfo;
    const reserveInput = this.state.listingInfo.reserveInput;
    const tickets = this.state.listingInfo.tickets;
    const location =
      listingInfo.tickets && this.state.listingInfo.tickets[0].location;
    const eventId =
      listingInfo.eventInfo && this.state.listingInfo.eventInfo.eventId;
    const fees = this.state.listingInfo.fees;
    const totalPrice = fees
      ? fees.finalTicketPrice * fees.quantity +
        fees.buyerFee * fees.quantity +
        fees.opfFee +
        fees.totalBuyerTax.amount
      : null;
    const seatMap =
      eventId &&
      `https://mapsapi.tmol.io/maps/geometry/3/event/${eventId}/image?systemId=HOST&sectionNames=${location.section}&placeSRS=${location.section},${location.row},${location.seat}&sectionLevel=true&w=280&pw=30&app=PRD2663_FANSELLER_NA&pt=circle`;
    //const seatMap =
    //  "https://mapsapi.tmol.io/maps/geometry/3/event/07005F1125D9615B/image?systemId=HOST&sectionNames=105ADA&placeId=GEYDKQKEIE5DENJ2GE3A&sectionLevel=true&w=280&pw=30&app=PRD2663_FANSELLER_NA&pt=circle";
    
      const formatDate = (dateString, timeString) => {
       return moment(dateString+' '+timeString, 'YYYY-MM-DD HH:mm:ss').format('ddd . MMM D, YYYY . h:mm A');
    };

    //eventId = 3F00583BA0F5729A, systemId = HOST, sectionNames=FLOOR, placeId=IZGE6T2SHIYTIORTHE, placeSRS=SECTION,ROWNo,SEATNo
    //https://mapsapi.tmol.io/maps/geometry/3/event/07005F1125D9615B/image?systemId=HOST&sectionNames=105ADA&placeId=GEYDKQKEIE5DENJ2GE3A&sectionLevel=true&w=280&pw=30&app=PRD2663_FANSELLER_NA&pt=circle
    //https://maps.intqa102.nonprod-tmaws.io/maps/geometry/3/event/3F00583BA0F5729A/image?systemId=HOST&sectionNames=FLOOR&placeSRS=FLOOR,15,29&sectionLevel=true&w=280&pw=30&app=PRD2663_FANSELLER_NA&pt=circle

    return (
      <div>
        {!this.state.isLoading && listingInfo.eventInfo && (
          <OpenGraph
            pageTitle={listingInfo.eventInfo.eventName}
            pageImage={listingInfo.eventInfo.image}
            pageDescription={`${formatDate(listingInfo.eventInfo.localDate,listingInfo.eventInfo.localTime)}, ${
              listingInfo.eventInfo.venue
            }, ${listingInfo.eventInfo.location}`}
          />
        )}
        <ContentTransition
          minHeight={800}
          keyProp={"TopLoader"}
          showOverlayContent={this.state.isLoading}
          groupStyles={this.contentTransitionGroupStyles}
          overlayContent={<Loader />}
        >
          {!this.state.isLoading &&
            !listingInfo.eventInfo &&
            this.state.isError && (
              <SocialShareError
                errorDetails={this.state.errorDetails}
                css={this.props.css}
              />
            )}
          {!this.state.isLoading && listingInfo.eventInfo && (
            <Content>
              <TopWrapper>
                <EventDetailsContainer>
                  <EventDetails>
                    <EventImageContainer>
                      <EventImage src={listingInfo.eventInfo.image} />
                    </EventImageContainer>
                    <EventInfo>
                      <EventTitle>{listingInfo.eventInfo.eventName}</EventTitle>
                      <EventDate>
                      {formatDate(listingInfo.eventInfo.localDate,listingInfo.eventInfo.localTime)}
                      </EventDate>
                      <EventVenue>{`${listingInfo.eventInfo.venue}, ${listingInfo.eventInfo.location}`}</EventVenue>
                    </EventInfo>
                  </EventDetails>
                  <Separator />
                  <TicketLocation>
                    <SeatColumn>
                      <FormattedMessage id="social-share.title.sec" />
                      <p>{location.section}</p>
                    </SeatColumn>
                    <SeatColumn>
                      <FormattedMessage id="social-share.title.row" />
                      <p>{location.row}</p>
                    </SeatColumn>
                    <SeatColumn>
                      <FormattedMessage id="social-share.title.seat" />
                      <p>
                        {tickets.length > 1
                          ? tickets[0].location.seat +
                            "-" +
                            tickets[tickets.length - 1].location.seat
                          : location.seat}
                      </p>
                    </SeatColumn>
                  </TicketLocation>
                </EventDetailsContainer>
                <SeatMapContainer>
                  <Separator isMobile />
                  <SeatMap src={seatMap} />
                </SeatMapContainer>
              </TopWrapper>
              {this.state.isError && (
                <BottomWrapper>
                  <SocialShareError
                    errorDetails={this.state.errorDetails}
                    css={this.props.css}
                    eventId={listingInfo.eventInfo.eventId}
                  />
                </BottomWrapper>
              )}
              {!this.state.isError && (
                <BottomWrapper>
                  <TotalRow>
                    <TaxLegend>
                      <FormattedMessage id="social-share.title.total" />{" "}
                      <FormattedMessage
                        id="social-share.legend.included-tax"
                        values={{
                          tax: fees.totalBuyerTax.amount.toFixed(2),
                        }}
                      />
                    </TaxLegend>
                    <p>${totalPrice.toFixed(2)}</p>
                  </TotalRow>

                  <h2>
                    <FormattedMessage id="social-share.title.tickets" />
                  </h2>
                  <BreakdownRow>
                    <p>
                      <FormattedMessage id="social-share.sub-title.verified-resale" />
                      {fees.quantity > 1
                        ? ` $${fees.finalTicketPrice.toFixed(2)} x ${
                            fees.quantity
                          }`
                        : ""}
                    </p>
                    <p>
                      {" "}
                      ${(fees.finalTicketPrice * fees.quantity).toFixed(2)}
                    </p>
                  </BreakdownRow>

                  <h2>
                    <FormattedMessage id="social-share.title.fees" />
                  </h2>
                  <BreakdownRow>
                    <p>
                      <FormattedMessage id="social-share.sub-title.service-fees" />
                      {fees.quantity > 1
                        ? ` $${fees.buyerFee.toFixed(2)} x ${fees.quantity}`
                        : ""}
                    </p>
                    <p> ${(fees.buyerFee * fees.quantity).toFixed(2)}</p>
                  </BreakdownRow>
                  <BreakdownRow>
                    <FormattedMessage id="social-share.sub-title.fees" />
                    <p>${fees.opfFee.toFixed(2)}</p>
                  </BreakdownRow>
                  <h2>
                    <FormattedMessage id="social-share.title.taxes" />
                  </h2>
                  <BreakdownRow>
                    <div>
                      <FormattedMessage id="social-share.sub-title.taxes" />
                      <TaxBottomLegend>
                        {" "}
                        <FormattedMessage id="social-share.legend.tax" />
                      </TaxBottomLegend>
                    </div>
                    <p> ${fees.totalBuyerTax.amount.toFixed(2)} </p>
                  </BreakdownRow>
                  <div>
                    <Separator />
                    <TitleInfo>
                      <FormattedMessage id="social-share.title.info" />
                    </TitleInfo>
                    <AvailabilityMessage>
                      <FormattedMessage
                        id="social-share.advice.availability"
                        values={{
                          link: (
                            <Link
                              target="_blank"
                              tabIndex="-1"
                              href={
                                this.props.messages[
                                  "social-share.link.availability"
                                ]
                              }
                            >
                              <FormattedMessage id="sell-instantly.LearnMore" />
                            </Link>
                          ),
                        }}
                      />
                    </AvailabilityMessage>
                  </div>
                  <SocialShareInfoMessages
                    sendDataToParent={this.handleTermsAccepted}
                    eventInfo={listingInfo.eventInfo}
                    checkBoxRequired={this.checkBoxRequired(
                      listingInfo.eventInfo
                    )}
                  />
                  <GetTicketsButton
                    data-bdd="get-tickets"
                    onClick={() => this.buttonHandler(reserveInput)}
                    disabled={!this.state.hasAcceptedTerms && this.checkBoxRequired(listingInfo.eventInfo)}
                  >
                    <FormattedMessage id="social-share.button.get" />
                  </GetTicketsButton>
                </BottomWrapper>
              )}
            </Content>
          )}
        </ContentTransition>
      </div>
    );
  }
}

export default SocialShare;
